"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenDownloadButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./DownloadButton.scss");
var models_1 = require("@app/_state/models");
var DownloadButton_1 = require("@app/components/packages/DownloadButton");
var OpenDownloadButton = function (props) {
    var asperaEnabled = props.asperaEnabled, maxDownloadSizeInMB = props.maxDownloadSizeInMB, onDownload = props.onDownload, onOpenDownload = props.onOpenDownload, pkg = props.pkg, showDownloadBtn = props.showDownloadBtn;
    var pkgExpired = pkg.pkgState === models_1.PackageState.DELETED;
    var downloadIcon = 'fa-folder-open';
    if (!asperaEnabled || (asperaEnabled && ((!pkg.state && pkg.state !== models_1.PackageTransferState.COMPLETE) && !pkg.packageTransferId))) {
        if (showDownloadBtn) {
            return (react_1.default.createElement(DownloadButton_1.DownloadButton, { disabled: false, pkg: pkg, pkgExpired: pkgExpired, maxDownloadSizeInMB: props.asperaEnabled ? undefined : maxDownloadSizeInMB, onDownload: onDownload }));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null));
        }
    }
    else {
        return (react_1.default.createElement("div", { style: { lineHeight: '1rem' } },
            react_1.default.createElement("a", { onClick: function (e) { e.stopPropagation(); onOpenDownload(); }, className: classnames_1.default('download-button', 'is-orange') },
                react_1.default.createElement("span", { className: "icon" },
                    react_1.default.createElement("i", { className: classnames_1.default('far', downloadIcon, 'fa-lg') })),
                react_1.default.createElement("p", null, "Open"))));
    }
};
exports.OpenDownloadButton = OpenDownloadButton;
